<canvas class="codigo-qr-component"></canvas>